import React from 'react';
import { DynamicComponent } from '../../Base';
import { Trans } from '@lingui/macro';

// TODO: Consider using ProductPricing from Gatsby

export default function ExactPrice({ pricing, style, orientation }) {
  return (
    <DynamicComponent.Wrapper style={style} orientation={orientation}>
      <DynamicComponent.Label orientation={orientation}>
        <Trans>Price</Trans> ({pricing?.priceType})
      </DynamicComponent.Label>
      <DynamicComponent.Value orientation={orientation}>
        {getPrice(pricing)}
      </DynamicComponent.Value>
    </DynamicComponent.Wrapper>
  );
}

function getPrice(pricing) {
  if (!pricing?.price) return 'Enquire for price';
  else return `${pricing.currency}${pricing?.price}`;
}
